// extracted by mini-css-extract-plugin
export var button = "_2g-1";
export var featuredLink = "_2g-4";
export var spinner = "_2g-2";
export var spinnerContainer = "_2g-3";
export var text = "_2g-0";